import { Paralax1 as c } from "../EditPanel/Paralax1";
import { conLanding } from "../Models/Landing";

export default class Paralax1 extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}